(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tz-pdp-bundle-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tz-bundle-offers')) {
    customElements.define('tz-bundle-offers', class TzBundleOffers extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.sectionId = this.dataset.sectionId;
        this.productInfo = this.closest('product-info') || this.closest('.shopify-section') || document;
        this.form = document.getElementById(`product-form-${this.sectionId}`) || this.productInfo.querySelector('form[action*="/cart/add"]');
        this.idInput = this.form?.querySelector('input[name="id"]');
        this.mainOptionNames = this.readJson('[data-tz-main-option-names]', []);
        this.mainVariants = this.readJson('[data-tz-main-variants]', []);
        this.mainVariantId = this.idInput?.value || String(this.mainVariants.find((variant) => variant.available)?.id || '');
        this.cards = [...this.querySelectorAll('[data-tz-purchase-card]')];
        this.offers = [...this.querySelectorAll('[data-tz-bundle-offer]')];
        this.addBundleLabel = this.querySelector('[data-tz-add-bundle-label]')?.textContent.trim() || '';
        this.bundleUnavailableLabel = this.querySelector('[data-tz-bundle-unavailable-label]')?.textContent.trim() || '';
        this.submitButton = this.form?.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.loadingLabel = this.querySelector('[data-tz-bundle-loading-label]')?.textContent.trim() || '';
        this.lookupErrorLabel = this.querySelector('[data-tz-bundle-retry-label]')?.textContent.trim() || '';
        this.bundleStatus = this.querySelector('[data-tz-bundle-status]');
        this.originalSubmitLabel = this.submitButtonText?.textContent || '';

        this.addEventListener('change', (event) => this.onBundleChange(event));
        this.productInfo.addEventListener('change', (event) => this.onProductChange(event));
        this.form?.addEventListener('submit', (event) => this.onSubmit(event), true);

        this.refreshMainVariant();
        this.updateEligibility();
        this.updateSelection();
      }

      readJson(selector, fallback) {
        try {
          return JSON.parse(this.querySelector(selector)?.textContent || '');
        } catch (error) {
          return fallback;
        }
      }

      onBundleChange(event) {
        if (!event.target.matches('[data-tz-purchase-option], [data-tz-bundle-option]')) return;
        const selectedOffer = event.target.matches('[data-tz-purchase-option]')
          ? event.target.closest('[data-tz-bundle-offer]')
          : null;
        if (selectedOffer) this.selectFirstAvailableVariant(selectedOffer);
        this.remoteKey = null;
        this.updateSelection();
      }

      onProductChange(event) {
        if (this.contains(event.target)) return;
        window.setTimeout(() => {
          this.refreshMainVariant();
          this.updateEligibility();
          const selectedOffer = this.querySelector('[data-tz-purchase-option]:checked')?.closest('[data-tz-bundle-offer]');
          if (selectedOffer) this.selectFirstAvailableVariant(selectedOffer);
          this.updateSelection();
        }, 0);
      }

      refreshMainVariant() {
        const inputValue = this.idInput?.value;
        const inputVariant = this.mainVariants.find((variant) => String(variant.id) === String(inputValue));
        if (inputVariant) this.mainVariantId = String(inputVariant.id);
        this.mainVariant = this.mainVariants.find((variant) => String(variant.id) === String(this.mainVariantId)) || this.mainVariants[0];
        this.updateProductPrice();
      }

      updateProductPrice() {
        if (!this.mainVariant) return;
        const price = this.querySelector('[data-tz-product-price]');
        const compare = this.querySelector('[data-tz-product-compare]');
        if (price) price.textContent = this.formatMoney(this.mainVariant.price);
        if (!compare) return;
        const showCompare = Number(this.mainVariant.compareAtPrice) > Number(this.mainVariant.price);
        compare.hidden = !showCompare;
        if (showCompare) compare.textContent = this.formatMoney(this.mainVariant.compareAtPrice);
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'USD';
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency
        }).format(Number(cents) / 100);
      }

      mainOptionValue(name) {
        const index = this.mainOptionNames.indexOf(name);
        return index >= 0 ? this.mainVariant?.options?.[index] : null;
      }

      updateEligibility() {
        let eligibleCount = 0;
        this.offers.forEach((offer) => {
          const optionName = offer.dataset.eligibleOptionName;
          const optionValue = offer.dataset.eligibleOptionValue;
          const eligible = !optionName || !optionValue || this.mainOptionValue(optionName) === optionValue;
          offer.hidden = !eligible;
          if (eligible) eligibleCount += 1;
          if (!eligible && offer.querySelector('[data-tz-purchase-option]')?.checked) {
            this.querySelector('[data-tz-purchase-option][value="product"]').checked = true;
          }
        });
        this.hidden = eligibleCount === 0;
      }

      updateSelection() {
        const selected = this.querySelector('[data-tz-purchase-option]:checked');
        this.cards.forEach((card) => card.classList.toggle('is-selected', card.contains(selected)));

        const selectedOffer = selected?.closest('[data-tz-bundle-offer]');
        this.selectedOffer = selectedOffer || null;
        if (selectedOffer) {
          const mappedValue = this.mainOptionValue(selectedOffer.dataset.mainOptionName);
          const mappedOutput = selectedOffer.querySelector('[data-tz-mapped-option-value]');
          if (mappedOutput) mappedOutput.textContent = mappedValue || '';
          if (this.readOfferJson(selectedOffer).remote) {
            this.resolveRemoteVariant(selectedOffer, mappedValue);
            return;
          }
          this.cancelLookup();
          this.selectedBundleVariant = this.findBundleVariant(selectedOffer, mappedValue);
          this.setSubmitState(Boolean(this.selectedBundleVariant?.available));
        } else {
          this.cancelLookup();
          this.selectedBundleVariant = null;
          this.restoreSubmitState();
        }
      }

      cancelLookup() {
        this.lookupController?.abort();
        this.lookupController = null;
        this.remoteKey = null;
        this.submitButton?.removeAttribute('aria-busy');
        if (this.bundleStatus) this.bundleStatus.textContent = '';
      }

      async resolveRemoteVariant(offer, mappedValue) {
        const data = this.readOfferJson(offer);
        const values = data.optionNames.map((name) => name === offer.dataset.bundleOptionName
          ? mappedValue
          : offer.querySelector(`[data-tz-bundle-option][data-option-name="${CSS.escape(name)}"]`)?.value);
        const ids = values.map((value, index) => data.optionValues[index]?.find((item) => item.name === value)?.id);
        const key = JSON.stringify([data.url, ids]);
        if (key === this.remoteKey) {
          this.setSubmitState(Boolean(this.selectedBundleVariant?.available));
          if (this.lookupController && this.submitButtonText) this.submitButtonText.textContent = this.loadingLabel;
          return;
        }
        this.cancelLookup();
        this.remoteKey = key;
        this.selectedBundleVariant = null;
        this.setSubmitState(false);
        const error = offer.querySelector('[data-tz-bundle-error]');
        if (error) error.hidden = true;
        if (ids.some((id) => !id)) return;
        const controller = new AbortController();
        this.lookupController = controller;
        this.submitButton?.setAttribute('aria-busy', 'true');
        if (this.submitButtonText) this.submitButtonText.textContent = this.loadingLabel;
        if (this.bundleStatus) this.bundleStatus.textContent = this.loadingLabel;
        const timeout = window.setTimeout(() => controller.abort(), 10000);
        try {
          const url = new URL(data.url, window.location.origin);
          url.searchParams.set('section_id', 'tz-bundle-variant');
          url.searchParams.set('option_values', ids.join(','));
          const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url.toString(), { signal: controller.signal, cache: 'no-store' });
          if (!response.ok) throw new Error('Bundle lookup failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const payload = JSON.parse(html.querySelector('[data-tz-resolved-variant]')?.textContent || '');
          if (this.lookupController !== controller || this.selectedOffer !== offer || !this.isConnected) return;
          const variant = payload.variant;
          if (variant && (!variant.id || !variant.options?.every((value, index) => value === values[index]) || variant.options.length !== values.length)) {
            throw new Error('Bundle selection mismatch');
          }
          this.selectedBundleVariant = variant;
          this.setSubmitState(Boolean(variant?.available));
          if (this.bundleStatus) this.bundleStatus.textContent = variant?.available ? this.addBundleLabel : this.bundleUnavailableLabel;
          const price = offer.querySelector('.tz-bundle-offer__price strong');
          if (price && variant) price.textContent = this.formatMoney(variant.price);
        } catch (lookupError) {
          if (this.lookupController !== controller || this.selectedOffer !== offer || !this.isConnected) return;
          this.selectedBundleVariant = null;
          this.setSubmitState(false);
          if (error) {
            error.textContent = this.lookupErrorLabel;
            error.hidden = false;
          }
          if (this.bundleStatus) this.bundleStatus.textContent = this.lookupErrorLabel;
        } finally {
          window.clearTimeout(timeout);
          if (this.lookupController === controller) {
            this.lookupController = null;
            this.submitButton?.removeAttribute('aria-busy');
          }
        }
      }

      selectFirstAvailableVariant(offer) {
        if (this.readOfferJson(offer).remote) return;
        const mappedValue = this.mainOptionValue(offer.dataset.mainOptionName);
        const currentVariant = this.findBundleVariant(offer, mappedValue);
        if (currentVariant?.available) return;

        const data = this.readOfferJson(offer);
        const mappedOptionIndex = data.optionNames.indexOf(offer.dataset.bundleOptionName);
        const availableVariant = data.variants.find((variant) => {
          if (!variant.available) return false;
          return mappedOptionIndex < 0 || !mappedValue || variant.options[mappedOptionIndex] === mappedValue;
        });
        if (!availableVariant) return;

        data.optionNames.forEach((optionName, index) => {
          if (optionName === offer.dataset.bundleOptionName) return;
          const select = offer.querySelector(`[data-tz-bundle-option][data-option-name="${CSS.escape(optionName)}"]`);
          if (select) select.value = availableVariant.options[index];
        });
      }

      findBundleVariant(offer, mappedValue) {
        const data = this.readOfferJson(offer);
        const selectedValues = data.optionNames.map((optionName) => {
          if (optionName === offer.dataset.bundleOptionName) return mappedValue;
          return offer.querySelector(`[data-tz-bundle-option][data-option-name="${CSS.escape(optionName)}"]`)?.value || null;
        });
        return data.variants.find((variant) => variant.options.every((value, index) => value === selectedValues[index]));
      }

      readOfferJson(offer) {
        try {
          return JSON.parse(offer.querySelector('[data-tz-bundle-variants]')?.textContent || '');
        } catch (error) {
          return { optionNames: [], variants: [] };
        }
      }

      setSubmitState(available) {
        if (!this.submitButton) return;
        this.submitButton.disabled = !available;
        this.submitButton.setAttribute('aria-disabled', String(!available));
        if (this.submitButtonText) this.submitButtonText.textContent = available ? this.addBundleLabel : this.bundleUnavailableLabel;
      }

      restoreSubmitState() {
        if (!this.submitButton) return;
        const available = Boolean(this.mainVariant?.available);
        this.submitButton.disabled = !available;
        this.submitButton.setAttribute('aria-disabled', String(!available));
        if (this.submitButtonText) this.submitButtonText.textContent = this.originalSubmitLabel;
        if (this.idInput && this.mainVariantId) this.idInput.value = this.mainVariantId;
      }

      onSubmit(event) {
        if (!this.selectedOffer) {
          this.refreshMainVariant();
          if (this.idInput && this.mainVariantId) this.idInput.value = this.mainVariantId;
          return;
        }
        this.updateSelection();
        const error = this.selectedOffer.querySelector('[data-tz-bundle-error]');
        if (!this.selectedBundleVariant?.available) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (error) error.hidden = false;
          return;
        }
        if (error) error.hidden = true;
        if (this.idInput) this.idInput.value = this.selectedBundleVariant.id;
        window.setTimeout(() => {
          if (this.idInput && this.mainVariantId) this.idInput.value = this.mainVariantId;
        }, 0);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
